import { render, staticRenderFns } from "./QrcodeScanner.vue?vue&type=template&id=6765d970&scoped=true&lang=pug&"
import script from "./QrcodeScanner.vue?vue&type=script&lang=ts&"
export * from "./QrcodeScanner.vue?vue&type=script&lang=ts&"
import style0 from "./QrcodeScanner.vue?vue&type=style&index=0&id=6765d970&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6765d970",
  null
  
)

export default component.exports